import { render, staticRenderFns } from "./Ratings.vue?vue&type=template&id=c67cb286&scoped=true&"
import script from "./Ratings.vue?vue&type=script&lang=js&"
export * from "./Ratings.vue?vue&type=script&lang=js&"
import style0 from "./Ratings.vue?vue&type=style&index=0&id=c67cb286&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67cb286",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VScrollXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VCardSubtitle,VCol,VContainer,VRow,VScrollXTransition})
